import { useTranslation } from 'react-i18next'

import { Headline } from 'src/components/Headline/Headline'
import { Rating } from 'src/components/Rating/Rating'
import { Text } from 'src/components/Text/Text'
import { useLocale } from 'src/contexts/LocaleContext'
import { formatDate } from 'src/functions/dates/formatDate'

import styles from './ProductReviews.module.scss'

import type { ProductReview as ProductReviewType } from 'src/types/Product'

interface ProductReviewProps {
  review: ProductReviewType
}

export const ProductReview = ({ review }: ProductReviewProps) => {
  const { t } = useTranslation()
  const { locale } = useLocale()

  const customerName = review.customer.name || t('common.customer')

  return (
    <div className={styles.review}>
      {review.title && <Headline variant="h4">{review.title}</Headline>}
      {review.title !== review.comment && <Text variant="p">{review.comment}</Text>}

      <div className={styles.signature}>
        <Rating rating={review.rating} size="md" />
        <Text variant="span" bold>
          {customerName}
        </Text>
        <Text variant="span" suppressHydrationWarning>
          {formatDate(review.submittedAt, locale)}
        </Text>
      </div>
    </div>
  )
}
